import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useManualNetworkPointByUuid } from 'src/apis/monolith/use-network-point-by-uuid';
import { Form } from 'src/components/form/form';
import { NetworkPointSelect } from 'src/components/form/select/network-point-select/network-point-select';
import { z } from 'zod';

type Props = {
  initialOpen?: boolean; // Just needed for storybook
  initialSearch?: string; // Just needed for storybook
};

export const NetworkPointSearch: FC<Props> = ({
  initialOpen,
  initialSearch,
}) => {
  const navigate = useNavigate();
  const oldNetworkPoint = useManualNetworkPointByUuid();

  useEffect(() => {
    if (!oldNetworkPoint.response) return;
    navigate(
      `/platform/#/network-point/details/${oldNetworkPoint.response.data.id}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oldNetworkPoint.response]);

  return (
    <Form
      initialValues={{ globalNetworkPoint: undefined }}
      schema={networkPointSearchSchema}
      onSubmit={(values, helpers) => {
        if (values.globalNetworkPoint?.value) {
          oldNetworkPoint.execute(values.globalNetworkPoint.value);
          helpers.setFieldValue('globalNetworkPoint', undefined);
        }
      }}
      mode="search"
      constraintViolation={null}
      cancelOrResetButton={null}
      submitButton={null}
    >
      {({ submitForm }) => (
        <NetworkPointSelect
          name="globalNetworkPoint"
          label="Network Point"
          placeholder="Find a Network Point"
          hideLabel
          onChange={submitForm}
          pending={oldNetworkPoint.pending}
          initialOpen={initialOpen}
          initialSearch={initialSearch}
          floatingProps={{
            // we use end alignment to avoid layout jumping
            // (the popover stays open while we navigate to the details page
            // and in this moment the scollbar disappears and then reappears -
            // this would cause the popover to shift)
            placement: 'bottom-end',
          }}
        />
      )}
    </Form>
  );
};

const networkPointSearchSchema = z.object({
  globalNetworkPoint: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .optional(),
});
